module.exports = __webpack_public_path__ + "static/challenge-employsure-93d2cc941f97e7a09a82e9062b8f9165.jpeg";